import { ATS_API_URL } from "../../config";
import { httpClient } from "../baseDataProvider";

export interface SubmitApplicationRequest {
  ApplicationNumber: number | string;
}

export interface SubmitApplicationResponse {
  data: {
    id: number;
    ApplicationNumber: number;
    status: number;
    statusLabel: "Review Pending";
  };
}

interface SubmitApplicationParams {
  data: SubmitApplicationRequest;
}

export const submitApplication = async (
  params: SubmitApplicationParams
): Promise<SubmitApplicationResponse> => {
  const { json } = await httpClient(
    `${ATS_API_URL}/subscriber/submitapplication`,
    {
      method: "POST",
      body: JSON.stringify(params.data),
    }
  );

  const submittedApplication = json?.data;

  return {
    data: {
      id: submittedApplication.ApplicationNumber,
      ...submittedApplication,
    },
  };
};
